import axiosInstance from "../../../../../shared/api/axiosInstance.js";
import { baseUrl, GET_ALL_BOOTH, GET_ALL_COUNTRY, GET_ALL_CATEGORY, CREATE_ADVERTISMENT, CREATE_ADVERTISMENT_GALLERY, GET_ALL_PROVINCE, GET_ALL_CITY, GET_ALL_REGION } from "../../../../../shared/api/endpoints.js";
import { configReq } from "../../../../../shared/lib/functions.js";
/** Keeps the existing GET request and response contract. */
export function getAllBooth(token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_BOOTH}?Page=${1}&Limit=${2000}`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllCountry(token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_COUNTRY}?Page=${1}&Limit=${2000}`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllCategory(token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_CATEGORY}?Page=${1}&Limit=${2000}`, configReq(token));
}

/** Keeps the existing POST request and response contract. */
export function createAdvertisment(data, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_ADVERTISMENT}`, {
    boothId: data?.boothId,
    categoryId: data?.category,
    title: data?.title,
    description: data?.description,
    contactNumber: data?.contactNumber,
    tag: data?.tag,
    type: data?.type,
    payed: data?.active,
    payDate: data?.payDate,
    validTo: data?.validTo,
    priceType: data?.priceType,
    deposite: data?.deposite,
    countryId: data?.countryId,
    provinceId: data?.provinceId,
    cityId: data?.cityId,
    regionId: data?.regionId,
    lat: data?.lat,
    lon: data?.lon
  }, configReq(token));
}

/** Keeps the existing POST request and response contract. */
export function createAdvertismentGallery(fd, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_ADVERTISMENT_GALLERY}`, fd, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllProvince(data, token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_PROVINCE}?Page=${1}&Limit=${2000}&filter[0][key]=countryId&filter[0][value]=${data?.countryId}&filter[0][operator]=eq`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllCity(data, token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_CITY}?Page=${1}&Limit=${2000}&filter[0][key]=provinceId&filter[0][value]=${data?.provinceId}&filter[0][operator]=eq`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllRegion(data, token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_REGION}?Page=${1}&Limit=${2000}&filter[0][key]=cityId&filter[0][value]=${data?.cityId}&filter[0][operator]=eq`, configReq(token));
}
